import { z as zod } from 'zod';

import { PARTNER_STORE, PARTNER_VALIDATION } from '../store/PartnerStore';

export const partnerFormSchema = zod.object({
  name: zod
    .string()
    .min(PARTNER_VALIDATION.name_min_length, PARTNER_STORE.name_error_msg)
    .max(PARTNER_VALIDATION.name_max_length, PARTNER_STORE.name_error_msg),
  mobile: zod
    .string()
    .min(PARTNER_VALIDATION.mobile_min_length, PARTNER_STORE.mobile_error_msg)
    .regex(PARTNER_VALIDATION.mobile_regex, PARTNER_STORE.mobile_error_msg),
  city: zod.object(
    {
      key: zod.string().regex(/^\d+$/, PARTNER_STORE.city_error_msg),
      value: zod.string(),
      text: zod.string(),
    },
    { required_error: PARTNER_STORE.city_error_msg },
  ),
  vehicle: zod.object(
    {
      key: zod.string().regex(/^\d+$/, PARTNER_STORE.vehicle_error_msg),
      value: zod.string(),
      text: zod.string(),
    },
    { required_error: PARTNER_STORE.vehicle_error_msg },
  ),
  infoSource: zod.object(
    { key: zod.string(), value: zod.string(), text: zod.string() },
    { required_error: PARTNER_STORE.source_error_msg },
  ),
});

export type PartnerFormInput = zod.infer<typeof partnerFormSchema>;

export interface PartnerFormOutput {
  name: string;
  mobile: string;
  city: { id: number; name: string };
  vehicle: { id: number; name: string };
  infoSource: string;
}

export function toFormOutput(input: PartnerFormInput): PartnerFormOutput {
  return {
    name: input.name,
    mobile: input.mobile,
    city: { id: parseInt(input.city.key, 10), name: input.city.value },
    vehicle: { id: parseInt(input.vehicle.key, 10), name: input.vehicle.value },
    infoSource: input.infoSource.value
  };
}
